export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];



// WEBPACK FOOTER //
// ./src/shared/components/monthPicker/helpers/monthPickerConstants.js